'use client';

import { useEffect, useMemo, useState } from 'react';
import KottonseedSelect from 'src/app/(default)/_components/_common/Select';
import MinimalTiptapEditorViewer from 'src/components/_common/MinimalTiptapEditorViewer';
import { TERMS_TYPE } from 'src/utils/contants';

import { useTermsQuery } from '@/store/server/common/terms/terms.query';

const RecurringPolicy = () => {
  const { data: terms } = useTermsQuery({ termsType: TERMS_TYPE.RECURRING_PAYMENT });
  const [selectedTermSeq, setSelectedTermSeq] = useState<string>('');

  const options = useMemo(() => {
    if (!terms) return [];
    const optionList = terms.rows.map((term) => {
      return { label: term.title, value: String(term.sequence) };
    });
    return optionList;
  }, [terms]);

  const selectedContent = useMemo(() => {
    if (!terms || !selectedTermSeq) return '';
    const selectedTerm = terms.rows.find((term) => String(term.sequence) === selectedTermSeq);
    return selectedTerm ? selectedTerm.contents : '';
  }, [terms, selectedTermSeq]);

  // 첫 진입 시(아직 아무것도 선택 안 됨)에만 첫 항목 자동 선택.
  // React Query select 결과는 매 렌더마다 새 reference 가 될 수 있으므로 ref 비교 대신
  // `selectedTermSeq === ''` 으로 "초기 1회만" 조건을 명확히 한다.
  useEffect(() => {
    if (terms && terms.rows.length > 0 && selectedTermSeq === '') {
      requestAnimationFrame(() => {
        setSelectedTermSeq(String(terms.rows[0].sequence));
      });
    }
  }, [terms, selectedTermSeq]);

  return (
    <section className="mt-[76px] flex min-h-dvh w-full flex-col gap-15 px-5 pt-7.5 pb-40">
      <div className="flex w-full flex-col gap-2.5">
        <h1 className="w-full text-center typo-heading-1">정기결제 이용약관</h1>
        <KottonseedSelect
          options={options}
          value={selectedTermSeq}
          onValueChange={(value) => setSelectedTermSeq(value)}
        />
      </div>

      <MinimalTiptapEditorViewer contents={selectedContent} />
    </section>
  );
};

export default RecurringPolicy;
